<template>
  <vue-record-audio
      mode="press"
      @result="onResult"
  />
</template>

<script>
import Vue from 'vue'
import VueRecord from '@codekraft-studio/vue-record'
Vue.use(VueRecord)
export default {
  name: 'audioRecorder',
  methods:{
    onResult(data) {
      const file = new File([data], `${this.$moment().format('jYYYY/jM/jD_HH:MM')}.mp3`, {
        type: 'audio/mpeg',
      })
       let preview = URL.createObjectURL(file)
      this.$emit('preview',preview)
      this.$emit('file', file)
    },
  }
}
</script>

<style scoped>

</style>
